import React, { useState } from 'react';
import LocalModal from 'components/base/local-modal';
import { Button, Input, ToastMessage } from '@cokitchen/cokitchen-components';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';

const AddRoleModal = ({
  refreshData,
  show,
  onClose
}: {
  show: boolean;
  onClose: () => void;
  refreshData: () => void;
}) => {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    permissions: { procurement: 'write' }
  });
  const [loading, setLoading] = useState(false);
  const createRole = async () => {
    setLoading(true);

    try {
      const data = formData;
      await apiService.post('user/role', {
        data
      });
      toast(<ToastMessage message='User role created successfully' type='success' />);
      refreshData();
      onClose();
    } catch (e: any) {
      console.log(e);
    }
  };
  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const isFormValid = () => {
    return formData?.name && formData?.description && formData?.permissions;
  };
  return (
    <LocalModal
      isOpen={show}
      onRequestClose={() => {
        onClose();
      }}
      title='Add Role'
      contentClassName='!max-w-[442px]'>
      <div className='w-full flex flex-col gap-[28px]'>
        <Input
          type='text'
          label='Role'
          placeholder='e.g Lead Chef'
          name='name'
          className='w-full'
          design='bordered'
          value={formData?.name}
          onChange={(e) => handleChange(e)}
        />
        <Input
          type='text'
          label='Description'
          placeholder='Desscription'
          name='description'
          className='w-full'
          design='bordered'
          value={formData?.description}
          onChange={(e) => handleChange(e)}
        />
      </div>
      <div>
        <hr className='border-t-4 border-[#F7F7F8]' />
        <div className='flex gap-6 items-center justify-end mt-6 mx-[28px] ml-auto'>
          <Button
            variant='block'
            color='primary'
            small
            className='w-[153px] h-[43px]'
            onClick={createRole}
            loading={loading}
            disabled={!isFormValid()}>
            Confirm
          </Button>
        </div>
      </div>
    </LocalModal>
  );
};

export default AddRoleModal;
